
module.exports = str;

var repr = require('./repr.js');

function str(obj) {
	if(obj === undefined) {
		return '';
	}
	else if(obj == null) {
		return '';
	}
	else if(obj.toString) {
		return obj.toString();
	}
	else {
		return repr(obj);
	}
}

